<p class="text-red">
  <ng-content select="[error-message]"></ng-content>
</p>
<ng-content select="[pretitle]"></ng-content>
<ng-content select="[title]"></ng-content>
<ng-content></ng-content>
